<div [ngClass]="{ 'loading-container': true, 'm-0': noMargin, flex: alignSpinner !== 'center' }">
  <div
    [ngClass]="{
      loading: true,
      small: small,
      'ml-0 mr-auto': alignSpinner === 'left',
      'mr-0 ml-auto': alignSpinner === 'right'
    }"
    data-cy="spinner"
  ></div>
</div>
